import { FieldProps } from 'formik';
import { kebabCase } from 'lodash';
import React, { memo, useCallback, Fragment, FunctionComponent, ReactNode } from 'react';

import BasicFormField from './BasicFormField';
import CheckboxInput from './CheckboxInput';
import FormFieldError from './FormFieldError';

export interface CheckboxFormFieldProps {
    additionalClassName?: string;
    disabled?: boolean;
    name: string;
    id?: string;
    labelContent: ReactNode;
    onChange?(isChecked: boolean): void;
}

const CheckboxFormField: FunctionComponent<CheckboxFormFieldProps> = ({
    additionalClassName,
    disabled = false,
    labelContent,
    onChange,
    name,
    id,
}) => {
    const renderField = useCallback(({ field }: FieldProps) => (
        <Fragment>
            { <CheckboxInput
                { ...field }
                checked={ !!field.value }
                disabled={ disabled }
                id={ id || field.name }
                label={ labelContent }
            /> }

            <FormFieldError
                name={ name }
                testId={ `${kebabCase(name)}-field-error-message` }
            />
        </Fragment>
    ), [
        disabled,
        id,
        labelContent,
        name,
    ]);

    return <BasicFormField
        additionalClassName={ additionalClassName }
        name={ name }
        onChange={ onChange }
        render={ renderField }
    />;
};

export default memo(CheckboxFormField);
